import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';


export type VariantsProps = ApiMethodBase & {}

export const setConstraintIcon = ({
    eventEmitter,
}: VariantsProps) => {
    eventEmitter.emit(Event.constraintIconActive);
};
